// extracted by mini-css-extract-plugin
var _1 = "ViewportPopup_bottomLeft__OEYIq";
var _2 = "ViewportPopup_center__+BZPL";
var _3 = "ViewportPopup_closeButton__HHIKC";
var _4 = "ViewportPopup_error__O0gam";
var _5 = "ViewportPopup_popup__XAcpw";
var _6 = "ViewportPopup_success__8UtUf";
export { _1 as "bottomLeft", _2 as "center", _3 as "closeButton", _4 as "error", _5 as "popup", _6 as "success" }
